import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { fetchBusinessInvoiceApi } from '~/api';
import { DEFAULT_INVOICE } from '~/constants/defaultStates';
import { useBoolean } from '~/hooks/useBoolean';
import { useSelector } from '~/store';
import { selectBusinessUuid } from '~/store/slices/formSlice/selectors';
import { IInvoiceSerializer } from '~/types/invoice';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';

export function useInvoiceDetails(invoiceUuid: string | null) {
  const [isLoading, loadingActions] = useBoolean();
  const [invoiceData, setInvoiceData] = useState<IInvoiceSerializer>({ ...DEFAULT_INVOICE });
  const businessUuid = useSelector(selectBusinessUuid);

  async function getInvoiceData() {
    if (!invoiceUuid || !businessUuid) {
      setInvoiceData({ ...DEFAULT_INVOICE });

      return;
    }
    loadingActions.on();
    const promise = await fetchBusinessInvoiceApi(businessUuid, invoiceUuid);

    const response = await apiResponseHandler<IInvoiceSerializer>(promise);

    if (response.type === ApiResponseEnum.Success) {
      setInvoiceData(response.data);
    } else {
      toast.error('Failed to fetch Invoice data');
    }
    loadingActions.off();
  }

  useEffect(() => {
    getInvoiceData();
  }, [invoiceUuid, businessUuid]);

  return {
    isLoading,
    invoiceData,
  };
}
